module.exports = __webpack_public_path__ + "img/neural-network.ff8f6f0c.svg";